import { Linked } from "@type-r/models"
import { asTimelessDate, div, span } from "lqx-react";
import React from "react"
import { NotificationSubscription } from "../api/notificationSubscription";

export const NotificationSubscriptionsRenderer = ($active: Linked<NotificationSubscription>, actionButtonsProvider?) =>
    ({ data, style, index }) => {
        const card: NotificationSubscription = data.items[ index ];
        const isActive = $active.value == card;

        const onRowClicked = () => {
            $active.set(card);
        };

        return <ListRow style={ style }>
            <Card { ...{ active: isActive.toString(), onClick: onRowClicked } } key={ card.id }>
                <HeaderContainer>
                    <Bullet />
                    <Email>{ card.email }</Email>
                    <ProductCode>{ card.platformCode }</ProductCode>
                </HeaderContainer>
                <SubscriptionsContainer>
                    { card.subscriptions.map(s => s.description).join('; ') }
                </SubscriptionsContainer>
                <ButtonsContainer>
                    { actionButtonsProvider(card) }
                </ButtonsContainer>
                <Footer { ...{ active: isActive.toString() } } >
                    <FooterProperty><FooterLabel>Created On:</FooterLabel> { asTimelessDate(card.createdOn) }</FooterProperty>
                    <FooterProperty><FooterLabel>Created By:</FooterLabel> { card.createdBy } </FooterProperty>
                </Footer>
            </Card>
        </ListRow>
    }

const ListRow = div({
    display: 'grid',
    gridTemplateColumns: (props: any) => '1fr',
    paddingRight: '20px'
});

const Card = div({
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridTemplateRows: 'auto 1fr auto',
    gridTemplateAreas: `"header buttons"
                    "title buttons"
                    "footer footer"`,
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    width: '100%',
    height: '90px',
    background: '#FFFFFF',
    backgroundColor: (props: any) => props.active === 'true' ? '#F4FAFD' : '#FFFFFF',
    border: (props: any) => props.active === 'true' ? '1px solid #58C1EE' : '1px solid #F2F5F8'
});

const HeaderContainer = div({
    display: 'block',
    gridArea: 'header',
    gridAutoColumns: 'max-content',
    gridAutoFlow: 'column',
    gridGap: '5px',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '5px 10px 0'
});

const SubscriptionsContainer = div({
    color: 'black',
    fontFamily: 'Montserrat',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0px',
    textAlign: 'left',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    gridArea: 'title',
    padding: "0 10px 5px",
    display: 'grid',
    alignItems: 'center'
});

const ButtonsContainer = div({
    gridArea: 'buttons',
    display: 'grid',
    alignItems: 'center'
});

const Email = span({
    color: '#63a9dc',
    fontFamily: 'Montserrat',
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '13px',
    letterSpacing: '0px',
    textAlign: 'left',
    paddingLeft: '3px'
});

const ProductCode = span({
    color: '#bbc3cc',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    marginLeft: '5px'
});

const Bullet = div({
    display: 'inline-block',
    width: '6px',
    height: '6px',
    background: '#4297D6',
    borderRadius: '11px',
    verticalAlign: 'middle'
});

const Footer = div({
    gridArea: 'footer',
    borderTop: '2px solid #F2F5F8',
    borderLeft: '1px solid #F2F5F8',
    borderRight: '1px solid #F2F5F8',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    height: '28px',
    overflow: 'hidden',
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
    backgroundColor: (props: any) => props.active === 'true' ? '#E7F2F9' : '#F9FAFC',
    color: '#3E4B5F',
    display: 'flex',
    padding: '5px 10px',
    alignItems: 'center'
});

const FooterLabel = span({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '15px',
    color: '#829AB0',
    marginRight: '5px'
});

const FooterProperty = span({
    margin: '5px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
